var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwitchCurveBlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.778 1.889L13 4.11l-2.222 2.222",
    stroke: "#191C1E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 7.444v-1.11A2.222 2.222 0 015.222 4.11H13M5.222 14.11L3 11.889l2.222-2.222",
    stroke: "#191C1E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13 8.555v1.111a2.222 2.222 0 01-2.223 2.222H3",
    stroke: "#191C1E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEwLjc3NzggMS44ODg2N0wxMyA0LjExMDgzTDEwLjc3NzggNi4zMzI5OCIgc3Ryb2tlPSIjMTkxQzFFIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTMgNy40NDQzMlY2LjMzMzI0QzMgNS43NDM4OSAzLjIzNDEyIDUuMTc4NjcgMy42NTA4NSA0Ljc2MTk0QzQuMDY3NTkgNC4zNDUyIDQuNjMyOCA0LjExMTA4IDUuMjIyMTYgNC4xMTEwOEgxMi45OTk3IiBzdHJva2U9IiMxOTFDMUUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNNS4yMjIxNiAxNC4xMTA2TDMgMTEuODg4NEw1LjIyMjE2IDkuNjY2MjYiIHN0cm9rZT0iIzE5MUMxRSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0xMi45OTk3IDguNTU1MThWOS42NjYyNUMxMi45OTk3IDEwLjI1NTYgMTIuNzY1NiAxMC44MjA4IDEyLjM0ODggMTEuMjM3NkMxMS45MzIxIDExLjY1NDMgMTEuMzY2OSAxMS44ODg0IDEwLjc3NzUgMTEuODg4NEgzIiBzdHJva2U9IiMxOTFDMUUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K";
export { SvgSwitchCurveBlack as ReactComponent };